import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import * as lf from 'localforage';
/** @internal */
var instance;
/** @internal */
var stores = {};
/** @internal */
function getDriverString(driver) {
    if (!driver) {
        return '';
    }
    else if (typeof driver === 'string') {
        return driver;
    }
    else {
        return driver.slice().sort().join(',');
    }
}
/** @internal */
function getHash(cfg) {
    return [
        getDriverString(cfg.driver),
        cfg.name,
        cfg.size,
        cfg.storeName,
        cfg.version,
        cfg.description,
        cfg.cacheTime
    ].join('|');
}
/**
 * Creates localForage instances
 */
var InstanceFactory = (function () {
    function InstanceFactory() {
    }
    InstanceFactory_1 = InstanceFactory;
    InstanceFactory.factory = function () {
        if (!instance) {
            instance = new InstanceFactory_1();
        }
        return instance;
    };
    /** @internal */
    InstanceFactory.prototype.getInstance = function (cfg) {
        var hash = getHash(cfg);
        if (!stores[hash]) {
            stores[hash] = lf.createInstance(cfg);
        }
        return stores[hash];
    };
    /** @internal */
    InstanceFactory.provider = {
        provide: InstanceFactory_1,
        useFactory: InstanceFactory_1.factory
    };
    InstanceFactory = InstanceFactory_1 = tslib_1.__decorate([
        Injectable()
    ], InstanceFactory);
    return InstanceFactory;
    var InstanceFactory_1;
}());
export { InstanceFactory };



//////////////////
// WEBPACK FOOTER
// ./src/NgForage/instance-factory/InstanceFactory.service.ts
// module id = 8
// module chunks = 0 1